"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardNavigationButtons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_component_library_1 = require("@onegov/react-component-library");
var components_1 = require("../components");
var core_1 = require("../core");
var createContinueButtonProps = function (onContinue, stepForward, hasNextStep) {
    if (!onContinue) {
        return { isVisible: false };
    }
    if (onContinue === 'submit') {
        return { type: 'submit' };
    }
    return {
        type: 'button',
        onClick: typeof onContinue === 'function' ? onContinue : stepForward,
        isVisible: typeof onContinue === 'function' || hasNextStep,
    };
};
var WizardNavigationButtons = function (_a) {
    var onContinue = _a.onContinue, onSaveAndExit = _a.onSaveAndExit, onNavigatingBack = _a.onNavigatingBack;
    var step = (0, components_1.useWizardStepContext)().step;
    var canGoBack = step.hasPreviousStep;
    var handleStep = (0, core_1.useWizardStepHandlers)();
    var handleBack = function () {
        onNavigatingBack && onNavigatingBack();
        handleStep.back();
    };
    var continueButtonProps = createContinueButtonProps(onContinue, handleStep.forward, step.hasNextStep);
    return ((0, jsx_runtime_1.jsx)(react_component_library_1.NavigationButtons, { leftButtonConfig: __assign({ id: 'btnContinue', label: 'Continue' }, continueButtonProps), rightButtonConfig: {
            id: 'btnSaveAndExit',
            label: 'Save and exit',
            isVisible: !!onSaveAndExit,
            onClick: onSaveAndExit,
        }, backButtonConfig: {
            id: 'btnBack',
            isVisible: canGoBack,
            onClick: handleBack,
        } }));
};
exports.WizardNavigationButtons = WizardNavigationButtons;
//# sourceMappingURL=WizardNavigationButtons.js.map